import { Grid } from '@mui/material';
import PairingDates from '../PairingDates/PairingDates';
import { usePairingById } from '../../providers/PairingById';
// import { formatNumToTime } from '../../helpers/timeHelpers';

import './PairingSnapshot.scss';
// import Trip from './Trip/Trip';
import Loader from '../Loader/Loader';
import { getMonth, getYear } from '../../helpers/dateHelpers';
// import { useTranslation } from 'react-i18next';
import CommonPairingView from '../CommonPairingView/CommonPairingView';

export default function PairingSnapshot({ selectedDate }) {
  // const { t } = useTranslation();
  const pairingByIdContext = usePairingById();

  const selectedMonth = getMonth(selectedDate);
  const selectedYear = getYear(selectedDate);
  const daysToShowLastMonth: any = [];
  const daysToShowSelectedMonth: any = [];
  const daysToShowNextMonth: any = [];
  if (pairingByIdContext.pairingDataById?.dates) {
    pairingByIdContext.pairingDataById.dates.forEach((day: string) => {
      const pairingMonth = parseInt(day.split('-')[1]);
      const pairingYear = parseInt(day.split('-')[0]);
      const dayToShow = parseInt(day.split('-')[2]);

      if (selectedMonth && ((pairingMonth > selectedMonth && pairingYear === selectedYear) || (pairingYear > selectedYear))) {
        daysToShowNextMonth.push(dayToShow);
      }
      else if (selectedMonth && (pairingMonth === selectedMonth) && (pairingYear === selectedYear)) {
        daysToShowSelectedMonth.push(dayToShow);
      }
      else if (selectedMonth && ((pairingMonth < selectedMonth && pairingYear === selectedYear) || (pairingYear < selectedYear))) {
        daysToShowLastMonth.push(dayToShow);
      }
    })
  }

  return (
    <section className='pairingSnapshot-body'>
      {pairingByIdContext.loading ? <Loader showText={false} /> : <>
        <div>
          <Grid container className='pairingSnapShot-dialog-container' justifyContent='space-between' spacing={1}>
            <CommonPairingView details={pairingByIdContext.pairingDataById} myBlockMonth={false}/>
            <Grid item xs={2} lg={2}>
              <PairingDates month={selectedMonth} year={selectedYear} daysToShowSelectedMonth={daysToShowSelectedMonth} daysToShowLastMonth={daysToShowLastMonth} daysToShowNextMonth={daysToShowNextMonth} />
            </Grid>
          </Grid>
        </div>

      </>
      }
    </section>
  )
}
